import React from 'react';
import '../../Styles/Admin/ViewProfile.css'; // Optional: for custom styles

export default function ViewProfile() {
  const userName = localStorage.getItem('userName') || 'User';
  const userEmail = localStorage.getItem('userEmail') || '';

  return (
    <div className="profile-main-bg">
      <div className="profile-card">
        <div className="profile-avatar">
          <span className="profile-avatar-circle">
            <img src="/profile_placeholder.png" alt="Profile" style={{ width: 80, height: 80, borderRadius: '50%' }} />
          </span>
        </div>
        <div className="profile-name">{userName}</div>
        <input
          className="profile-input"
          type="text"
          value={userEmail}
          disabled
        />
        <input
          className="profile-input"
          type="password"
          value="Password"
          disabled
        />
      </div>
    </div>
  );
}